import loadable from '@loadable/component';

export const LazyAccount = loadable(() => import(/* webpackChunkName: "content/account" */ '.'));
